import React, { useState } from 'react';

const SECTIONS = {
  fondateurs: {
    title: 'Programme hôtes fondateurs',
    content: [
      {
        heading: "Qu'est-ce que le programme fondateurs ?",
        text: `Le programme hôtes fondateurs est une offre exclusive réservée aux 50 premiers hôtes à rejoindre Havenly. Ces hôtes bénéficient de conditions préférentielles en échange de leur confiance dans le projet dès son lancement.

Places disponibles : 23 sur 50
Offre réservée aux 50 premiers hôtes — à vie.`,
      },
      {
        heading: "Les avantages fondateurs",
        text: `Commission à 8% à vie pour les 50 premiers hôtes fondateurs (vs 12% standard et 15,5% chez Airbnb)
Pour les hôtes rejoignant après les 50 premiers, la commission est de 8% les 3 premiers mois, puis 12% — toujours inférieur à Airbnb.

Versement sous 24h après le check-in
Contre le 15 du mois suivant chez Booking et 24h après le check-in chez Airbnb.

Badge "Hôte Fondateur" sur votre annonce
Un badge exclusif qui rassure les voyageurs et distingue votre annonce.

Accès prioritaire aux nouvelles fonctionnalités
Les hôtes fondateurs testent et influencent les nouvelles fonctionnalités en avant-première.

Support dédié
Une ligne de support prioritaire avec temps de réponse garanti sous 2h.`,
      },
      {
        heading: "Simulation de gains",
        text: `Pour 1 000€ de réservations :
- Avec Havenly Fondateur (8%) : vous recevez 920€
- Avec Havenly Standard (12%) : vous recevez 880€
- Avec Airbnb (15,5%) : vous recevez 845€
- Avec Booking (17%) : vous recevez 830€

Sur 12 mois à 2 000€/mois (fondateur à vie) :
- Économie vs Airbnb : +1 800€
- Économie vs Booking : +2 160€`,
      },
      {
        heading: "Comment rejoindre le programme ?",
        text: `1. Créez votre compte Havenly
2. Complétez votre profil et vos documents de vérification
3. Publiez votre première annonce
4. Votre statut Fondateur est automatiquement attribué si des places sont disponibles

Le statut Fondateur démarre à la date de validation de votre première annonce par l'équipe Havenly.`,
      },
      {
        heading: "Conditions du programme",
        text: `Pour conserver le statut Fondateur :
- Maintenir une note moyenne ≥ 4,0
- Respecter les CGU de Havenly
- Compléter au moins 1 réservation par trimestre
- Ne pas avoir fait l'objet de sanctions pour comportement frauduleux

En cas de violation grave des CGU, Havenly se réserve le droit de révoquer le statut Fondateur après mise en demeure.`,
      },
    ],
  },

  emma: {
    title: 'Emma IA pour hôtes',
    content: [
      {
        heading: "Qu'est-ce qu'Emma ?",
        text: `Emma est l'assistante IA de Havenly, développée spécifiquement pour les hôtes de location courte durée. Elle répond automatiquement aux messages de vos voyageurs 24h/24, 7j/7, dans leur langue.

Emma est incluse gratuitement dans toutes les formules Havenly — aucun abonnement supplémentaire requis.`,
      },
      {
        heading: "Ce qu'Emma gère automatiquement",
        text: `Questions sur le logement :
- Équipements disponibles (WiFi, parking, piscine, climatisation...)
- Règles du logement (animaux, fumeurs, fêtes)
- Informations check-in et check-out
- Codes d'accès (envoyés automatiquement 48h avant l'arrivée)

Questions sur la réservation :
- Confirmation de réservation
- Politique d'annulation
- Dépôt de garantie
- Informations de paiement

Guide local :
- Restaurants et adresses recommandées par vous
- Activités et visites à proximité
- Transports et bons plans`,
      },
      {
        heading: "Les langues supportées",
        text: `Emma détecte automatiquement la langue du voyageur et répond dans sa langue :

- Français — langue principale
- Anglais — parfaitement maîtrisé
- Espagnol — niveau natif
- Allemand — niveau natif

D'autres langues seront ajoutées prochainement (italien, portugais, néerlandais).`,
      },
      {
        heading: "Personnaliser Emma",
        text: `Emma s'adapte à votre logement et vos règles. Depuis votre tableau de bord, vous pouvez :

- Ajouter des informations spécifiques à votre logement
- Définir les réponses aux questions fréquentes
- Personnaliser le ton (formel ou décontracté)
- Ajouter votre guide local
- Définir les questions à vous transférer directement

Emma apprend de vos corrections — plus vous l'utilisez, plus elle devient précise.`,
      },
      {
        heading: "Quand Emma vous transfère la conversation",
        text: `Emma ne prétend pas tout gérer. Elle vous transfère automatiquement :
- Les demandes inhabituelles ou complexes
- Les plaintes sérieuses
- Les demandes de modification tarifaire
- Toute situation où elle n'est pas sûre de la réponse

Vous recevez une notification push et email immédiate dès qu'un message vous est transféré.`,
      },
      {
        heading: "Statistiques Emma",
        text: `Depuis votre tableau de bord, consultez en temps réel :
- Nombre de messages gérés ce mois
- Temps de réponse moyen
- Taux de satisfaction des voyageurs
- Économie de temps estimée
- Messages transférés vs gérés automatiquement`,
      },
    ],
  },

  assurance: {
    title: 'Assurance hôte',
    content: [
      {
        heading: "Vos obligations légales",
        text: `En tant qu'hôte de location courte durée, vous avez des obligations d'assurance que Havenly ne peut pas remplacer.

Votre assurance habitation classique ne couvre généralement pas la location courte durée. Vous devez impérativement informer votre assureur de votre activité et obtenir un avenant ou une extension spécifique.

Sans cette démarche, vous pourriez ne pas être couvert en cas de sinistre grave (incendie, dégât des eaux important, blessure d'un voyageur).`,
      },
      {
        heading: "Ce que Havenly met en place",
        text: `Dépôt de garantie via Stripe :
Un dépôt de garantie (entre 30€ et 250€ selon le type de logement) est bloqué sur la carte du voyageur au check-in. En cas de dégradation prouvée par vos photos horodatées, ce montant peut être prélevé après arbitrage Havenly sous 72h. Il est libéré automatiquement 48h après le check-out sans signalement.

Photos d'état des lieux recommandées :
Havenly vous recommande des photos horodatées avant et après chaque séjour. Sans photos, aucun recours en cas de dégradation n'est possible. Ces photos constituent votre preuve en cas de litige.

Médiation sous 72h :
En cas de litige avec un voyageur, notre équipe intervient sous 72h et propose une résolution aux deux parties.`,
      },
      {
        heading: "Démarches recommandées",
        text: `1. Contactez votre assureur actuel et signalez votre activité de location courte durée

2. Demandez un avenant "location saisonnière" ou "meublé de tourisme"

3. Si votre assureur refuse ou le tarif est prohibitif, comparez les offres spécialisées (Luko, Assurly, April...)

4. Conservez votre attestation d'assurance et uploadez-la dans votre espace hôte Havenly

5. Renouvelez chaque année et mettez à jour votre document sur la plateforme`,
      },
      {
        heading: "Responsabilité civile",
        text: `Votre assurance doit couvrir la responsabilité civile hôte, c'est-à-dire les dommages corporels ou matériels causés à vos voyageurs pendant leur séjour.

Exemples couverts par la RC hôte :
- Chute d'un voyageur due à un défaut du logement
- Intoxication liée à un équipement défectueux
- Dommages causés par un incendie dans votre logement

Sans RC hôte valide, vous êtes personnellement responsable sur vos biens propres.`,
      },
      {
        heading: "Loi Le Meur 2024",
        text: `La loi du 19 novembre 2024 renforce les obligations des hôtes :

- Déclaration en mairie obligatoire (numéro d'enregistrement)
- Maximum 120 nuits/an pour une résidence principale (90 dans certaines communes)
- DPE classe A à E obligatoire pour tout changement d'usage
- Enregistrement via téléservice national — obligatoire avant le 20 mai 2026

Havenly vérifie votre numéro d'enregistrement avant publication de votre annonce.`,
      },
    ],
  },

  ressources: {
    title: 'Ressources hôtes',
    content: [
      {
        heading: "Guide de démarrage",
        text: `Vous venez de rejoindre Havenly ? Voici les étapes clés pour bien démarrer :

Étape 1 — Créez une annonce attractive
- Utilisez des photos professionnelles (ou de très bonne qualité)
- Rédigez une description honnête et détaillée
- Listez tous vos équipements
- Fixez un prix compétitif en vous basant sur nos suggestions

Étape 2 — Configurez Emma
- Ajoutez vos informations spécifiques
- Créez votre guide local
- Définissez vos règles maison
- Testez Emma en lui envoyant des messages types

Étape 3 — Préparez votre logement
- Photographiez chaque pièce en détail (état des lieux initial)
- Vérifiez que tous les équipements fonctionnent
- Préparez un guide d'accueil pour vos voyageurs
- Installez une boîte à clé sécurisée`,
      },
      {
        heading: "Optimiser son taux d'occupation",
        text: `Prix :
- Utilisez les tarifs saisonniers pour maximiser vos revenus
- Baissez légèrement le prix en basse saison pour maintenir l'occupation
- Restez compétitif en consultant les annonces similaires dans votre zone

Calendrier :
- Ouvrez votre calendrier au maximum
- Répondez rapidement aux demandes (sous 1h idéalement)
- Activez les réservations instantanées pour les profils vérifiés

Qualité :
- Maintenez une note ≥ 4,8 pour le badge Excellence
- Répondez à tous les avis (positifs et négatifs)
- Mettez à jour vos photos régulièrement`,
      },
      {
        heading: "Gérer les check-ins et check-outs",
        text: `Check-in :
- Envoyez les codes d'accès 48h avant (automatique avec Havenly)
- Préparez un guide d'accueil numérique (PDF ou lien)
- Photographiez le logement propre et prêt avant l'arrivée

Check-out :
- Envoyez un message de rappel la veille pour l'heure de départ
- Photographiez le logement dans les 2h après le départ
- Signalez tout dommage dans les 48h via votre tableau de bord`,
      },
      {
        heading: "Gérer les avis",
        text: `Les avis sont essentiels sur Havenly. Voici nos conseils :

Obtenir de bons avis :
- Sur-communiquer plutôt que sous-communiquer
- Anticiper les besoins (guide local, conseils pratiques)
- Proposer un petit geste de bienvenue (produits locaux, bouteille de vin)
- Répondre aux messages sous 30 minutes (Emma s'en charge)

Répondre aux avis négatifs :
- Restez professionnel et factuel
- Remerciez pour le retour
- Expliquez votre point de vue sans agressivité
- Mentionnez les améliorations apportées si pertinent`,
      },
      {
        heading: "Fiscalité de la location courte durée",
        text: `Régime Micro-BIC (recommandé pour débuter) :
- Abattement de 30% jusqu'à 15 000€ de revenus (meublé non classé)
- Abattement de 50% jusqu'à 77 700€ (meublé classé tourisme)
- Déclaration simplifiée sur votre déclaration de revenus

Régime réel :
- Déduction des charges réelles (amortissement, travaux, charges de copropriété)
- Recommandé si vos charges dépassent l'abattement forfaitaire
- Nécessite un comptable

Attention : ces informations sont indicatives. Consultez un expert-comptable pour votre situation personnelle.`,
      },
      {
        heading: "Support et communauté",
        text: `Vous n'êtes pas seul. Havenly met à votre disposition :

Support hôte :
- Email : contact@havenly.fr (réponse sous 4h en journée)
- Ligne dédiée fondateurs : réponse sous 2h

Prochainement :
- Groupe privé hôtes Havenly (partage d'expériences)
- Webinaires mensuels (optimisation, juridique, fiscal)
- Blog hôtes avec conseils et actualités`,
      },
    ],
  },
};

export default function HotePage({ onNavigate, hotePage }) {
  const [activePage, setActivePage] = useState(hotePage || 'fondateurs');
  const isMobile = window.innerWidth < 768;
  const section = SECTIONS[activePage] || SECTIONS['fondateurs'];

  const tabs = [
    { key: 'fondateurs', label: 'Programme fondateurs' },
    { key: 'emma', label: 'Emma IA' },
    { key: 'assurance', label: 'Assurance hôte' },
    { key: 'ressources', label: 'Ressources' },
  ];

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>

      {/* Header */}
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: isMobile ? '1.5rem 1rem 0' : '2rem 2rem 0' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <button onClick={() => onNavigate('home')} style={{ background: 'none', border: 'none', fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', padding: 0, marginBottom: 12 }}>
            ← Retour
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--green-mid)" strokeWidth="1.5"><path d="M3 21V9l9-6 9 6v12"/><path d="M9 21V13h6v8"/></svg>
            </div>
            <h1 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 22 : 28, letterSpacing: '-0.5px' }}>
              Espace hôtes
            </h1>
          </div>
          <div style={{ display: 'flex', gap: 0, overflowX: 'auto' }}>
            {tabs.map(tab => (
              <button key={tab.key} onClick={() => setActivePage(tab.key)} style={{
                padding: isMobile ? '10px 12px' : '12px 20px',
                border: 'none', background: 'transparent', cursor: 'pointer',
                fontFamily: 'var(--sans)', fontSize: isMobile ? 12 : 14,
                borderBottom: activePage === tab.key ? '2px solid var(--ink)' : '2px solid transparent',
                color: activePage === tab.key ? 'var(--ink)' : 'var(--ink-3)',
                fontWeight: activePage === tab.key ? 500 : 400,
                whiteSpace: 'nowrap',
              }}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '2.5rem 2rem' }}>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: isMobile ? '1.5rem' : '2.5rem' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 26, letterSpacing: '-0.5px', marginBottom: 32 }}>
            {section.title}
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            {section.content.map((block, i) => (
              <div key={i}>
                <h3 style={{ fontSize: 15, fontWeight: 500, marginBottom: 10 }}>{block.heading}</h3>
                <div style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                  {block.text}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div style={{ marginTop: 40, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            <div style={{ padding: '20px 24px', background: 'var(--green-light)', border: '1px solid var(--green)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--green-mid)', marginBottom: 6 }}>Prêt à publier ?</div>
              <div style={{ fontSize: 13, color: 'var(--green-mid)', lineHeight: 1.6, marginBottom: 12 }}>
                Rejoignez les hôtes fondateurs — 8% à vie.
              </div>
              <button onClick={() => onNavigate('auth', 'host')} style={{ fontSize: 13, fontWeight: 500, color: '#fff', background: 'var(--green)', border: 'none', borderRadius: 20, padding: '7px 16px', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                Publier mon annonce →
              </button>
            </div>
            <div style={{ padding: '20px 24px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Mon tableau de bord</div>
              <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.6, marginBottom: 12 }}>
                Gérez vos annonces, revenus et Emma.
              </div>
              <button onClick={() => onNavigate('dashboard')} style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink-3)', background: 'none', border: '1px solid var(--border)', borderRadius: 20, padding: '6px 16px', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                Accéder au tableau de bord →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
